<template>
  <div class="main__wrapper bg-white align-center">
    <div class="flex align-center flex-row">
      <div class="access__wrapper--helper relative">
        <SmartButton
          @click="isDateAccessOpen = !isDateAccessOpen"
          class="main__button flex align-center justify-center"
          :style="{ color: fomarttedDate ? 'white' : '' }"
          icon
          v-bind="buttonTypePeriod"
        >
          <SmartIcon class="mr-2" name="calendar" :size="2" type="small" />
          <p
            :style="{ fontSize: fomarttedDate ? '11px !important' : '' }"
            class="button__paragraph"
          >
            {{ fomarttedDate || "Período de Acesso" }}
          </p>
        </SmartButton>
        <DatePicker
          class="date-picker--access absolute"
          v-model="dateAccess"
          v-on-clickaway="awayAccess"
          v-if="isDateAccessOpen"
          inline
          range
          clearable
          range-separator="-"
          format="dddd"
        />
      </div>

      <div
        v-on-clickaway="awayUserOptions"
        class="users__wrapper--helper relative"
        style="margin-left: 10px"
      >
        <SmartButton
          @click="isUserOptionsOpen = !isUserOptionsOpen"
          class="main__button flex align-center justify-center"
          :style="{ color: btnTypeRegistrationWhiteText ? 'white' : '' }"
          icon
          v-bind="buttonTypeRegistration"
        >
          <SmartIcon class="mr-2" name="credit_card" :size="2" type="small" />
          <p
            :style="{
              fontSize: formattedRegistration ? '11px !important' : '',
            }"
            class="button__paragraph"
          >
            Matrícula
          </p>
        </SmartButton>

        <CheckBoxSearcher
          class="check-searcher absolute w-full"
          :style="{ display: userStyle }"
          itemLabel="name"
          itemValue="active"
          ref="checkboxSearcher"
          :checkboxItems="usersComputed"
          :clear="isClearingSearchers"
          @away-filter="awayViewOptions"
          @set-filter="setCheckBoxSearcherFilter"
          @search-item="handlerSearch"
          searchable
          mutationName="SET_USERS_FILTER"
          iconName="credit_card"
          :iconSize="2"
          headerTitle="Matrículas"
        />
      </div>
      <v-divider style="margin-left: 5px" vertical />
      <div>
        <SmartButton
          @click="clearFilters"
          icon
          class="flex align-center justify-center"
          style="margin-left: 10px"
          tertiary
        >
          <SmartIcon name="trash" :size="2" type="small" />
        </SmartButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mixin as clickaway } from "vue-clickaway";
import moment from "moment";

export default {
  name: "AccessReportFilter",
  components: {
    CheckBoxSearcher: () => import("./CheckBoxSearcher.vue"),
    DatePicker: () => import("vue2-datepicker"),
  },
  mixins: [clickaway],
  data() {
    return {
      isDateAccessOpen: false,
      isUserOptionsOpen: false,
      dateAccess: "",
      userStyle: "none",
      registrationStyle: "none",
      viewStyle: "none",
      visitDate: "",
      generatedDate: "",
      fomarttedDate: "",
      formattedRegistration: "",
      emitted: false,
      isClearingSearchers: false,
      isClearingIds: false,
      filter: {},
      usersComputed: [],
      buttonTypeRegistration: { tertiary: true },
      buttonTypePeriod: { tertiary: true },
      btnTypeRegistrationWhiteText: false,
      moment,
    };
  },
  watch: {
    users() {
      this.usersComputed = this.users.map((item) => ({
        ...item,
        active: false,
      }));
    },
    dateAccess(value) {
      this.awayAccess();
      if (value) {
        this.isDateAccessOpen = false;
        this.momentFormat();
      }
    },
    isUserOptionsOpen(value) {
      if (value) {
        this.userStyle = "block";
      } else {
        this.userStyle = "none";
      }
    },
    fomarttedDate(value) {
      if (value) {
        this.buttonTypePeriod = {};
      }
    },
    formattedRegistration(value) {
      if (value) {
        this.buttonTypeRegistration = {};
      }
    },
  },
  computed: {
    ...mapGetters({
      ids: "guReports/ids",
      users: "guReports/users",
    }),
    formattedDateAccess() {
      return this.dateAccess.map((date) => moment(date).format("YYYY-MM-DD"));
    },
  },
  methods: {
    ...mapActions({
      clearSearchers: "guReports/clearSearchers",
      fetchAccessReportList: "guReports/fetchAccessReportList",
      fetchUsers: "guReports/fetchUsers",
    }),
    setCheckBoxSearcherFilter(searchParams) {
      if (searchParams.mutationName === "SET_USERS_FILTER") {
        this.btnTypeRegistrationWhiteText = true;
        this.buttonTypeRegistration = {};

        const registrations = searchParams.checkboxValues.map(
          (user) => user.registration
        );
        this.filter.registration = [...registrations];

        this.$emit("save-filter", this.filter);
        return;
      }
    },
    awayUsersOptions() {
      this.isUsersOptionOpen = false;
    },
    async awayAccess() {
      if (this.dateAccess) {
        this.isDateAccessOpen = false;

        const dateStart = this.formattedDateAccess[0];
        const dateEnd = this.formattedDateAccess[1];

        this.filter.date_start = dateStart;
        this.filter.date_end = dateEnd;

        this.$emit("skeleton-handler", true);
        await this.fetchAccessReportList({ DTO: this.filter });
        this.$emit("skeleton-handler", false);

        this.$emit("save-filter", this.filter);
      } else {
        this.isDateAccessOpen = false;
      }
    },
    async clearFilters() {
      this.filter = {};
      this.fomarttedDate = "";
      this.formattedRegistration = "";
      this.buttonTypeRegistration = { tertiary: true };
      this.buttonTypePeriod = { tertiary: true };
      this.btnTypeRegistrationWhiteText = false;
      this.clearSearchers(false);

      this.$emit("skeleton-handler", true);
      await this.fetchAccessReportList({ DTO: this.filter });
      this.$emit("skeleton-handler", false);

      this.$emit("save-filter", this.filter);
    },
    momentFormat() {
      this.fomarttedDate = `
      ${this.moment(this.dateAccess[0]).format("DD/MM/YYYY")}-${this.moment(
        this.dateAccess[1]
      ).format("DD/MM/YYYY")}
      `;
    },
    awayViewOptions() {
      this.isViewOptionsOpen = false;
    },
    awayUserOptions() {
      this.isUserOptionsOpen = false;
    },
    handlerSearch({ mutationName, search }) {
      if (mutationName === "SET_USERS_FILTER") {
        const filterOptions = {
          registration: search,
        };
        this.fetchUsers({ filterOptions });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main__wrapper {
  display: block;
  padding: 1%;
  border: 1px solid #e3e5e6;
  border-radius: 6px;
  height: 65px;
  z-index: 101;
  margin-right: 2px;
  margin-top: 15px;
}

.date-picker--access {
  margin-top: 10px;
  z-index: 9;
}

.date-picker--visitDate {
  bottom: 0;
  margin-top: 10px;
}

.date-picker--visit {
  margin-top: 10px;
}

.button__paragraph {
  font-size: 15px;
  font-weight: 400;
}

.access__wrapper--helper {
  max-height: 40px;
  max-width: 286px;
  width: 199px;
}

.visitDate__wrapper--helper {
  max-width: 170px;
  width: 170px;
  max-height: 40px;
  height: 40px;
  z-index: 9;
  margin-right: 15px;
}

.visit__wrapper--helper {
  max-width: 170px;
  width: 170px;
  max-height: 40px;
  height: 40px;
  z-index: 9;
  margin-right: 15px;
}

.generatedDate__wrapper--helper {
  max-width: 170px;
  width: 170px;
  max-height: 40px;
  height: 40px;
  z-index: 8;
  margin-right: 15px;
}

.users__wrapper--helper {
  max-width: 170px;
}

.status__wrapper {
  width: 320px;
  box-shadow: 0px 4px 8px rgba(51, 51, 51, 0.13);
  border-radius: 6px;
  padding: 16px;
  margin-top: 10px;
  z-index: 9;

  & .check-group {
    max-width: 250px;
    flex-wrap: wrap;
  }
}

.ecofrotas__wrapper {
  width: 320px;
  box-shadow: 0px 4px 8px rgba(51, 51, 51, 0.13);
  border-radius: 6px;
  padding: 16px;
  margin-top: 10px;
  z-index: 9;

  & .check-group {
    max-width: 250px;
    flex-wrap: wrap;
  }
}

.main__button {
  color: #919699;
  border: 1px solid #c6cacc;
  margin: 0 5px 0 5px;
  overflow: hidden;
  white-space: nowrap;
}

.check-searcher {
  margin-top: 10px;
  z-index: 9;
}
</style>
